import React, { Component } from 'react';
import styled from 'styled-components';

import { vw, vwMobile } from 'src/styles/utils';
import media from 'src/styles/media';

import VideoPlayer from 'components/VideoPlayer';

export default class VideoSection extends Component {
  state = {
    showVideo: false,
  };

  handleClickPlay = () => {
    this.setState({
      showVideo: true,
    });
  };

  render() {
    return (
      <Root id="home-video-player">
        <VideoPlayer
          url="https://media.bamdigital.com/gryphon/shared/gryphon-compilation-220823-1-1080p.mp4"
          background={require('src/assets/images/home/video-bg.jpg')}
          aspectRatio={50}
          autoPlay
          muted
          videoSrc
        >
          <TextImages>
            <img
              src={require('src/assets/images/home/gryphon-white.svg')}
              alt=""
            />
          </TextImages>
        </VideoPlayer>
      </Root>
    );
  }
}

const Root = styled.div``;

const TextImages = styled.div`
  display: flex;
  align-items: flex-start;
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  padding-bottom: ${vw(20)};
  img {
    height: ${vw(30)};
  }
  @media (max-width: ${media.md}) {
    top: 12%;
    img {
      height: ${vwMobile(20)};
    }
  }
  @media (max-width: ${media.sm}) {
    display: none;
  }
`;
